import { createReducer } from 'redux-act';
import { oAuthLoginInitiated, oAuthLoginSuccess, oAuthLogout, oAuthClearAuthentication, oAuthFailure } from './actions';
import { AuthenticationState } from '../types';
import { OAuthUserState } from './types';

export const initialState: OAuthUserState = {
  memberId: undefined,
  title: undefined,
  firstName: undefined,
  lastName: undefined,
  pointsBalance: undefined,
  membershipTier: undefined,
  isAuthenticated: false,
  isAuthenticating: false,
  error: undefined,
};

export const reducerBranches = {
  [oAuthLoginInitiated as any]: (state: AuthenticationState) => ({
    ...state,
    oAuthUser: {
      ...state.oAuthUser,
      isAuthenticating: true,
    },
  }),
  [oAuthLoginSuccess as any]: (state: AuthenticationState, payload: OAuthUserState) => ({
    ...state,
    oAuthUser: {
      ...initialState,
      ...payload,
      isAuthenticated: true,
      isAuthenticating: false,
    },
  }),
  [oAuthLogout as any]: (state: AuthenticationState) => ({
    ...state,
    oAuthUser: {
      ...initialState,
    },
  }),
  [oAuthClearAuthentication as any]: (state: AuthenticationState) => ({
    ...state,
    oAuthUser: {
      ...initialState,
    },
  }),
  [oAuthFailure as any]: (state: AuthenticationState, payload: Error) => ({
    ...state,
    oAuthUser: {
      ...state.oAuthUser,
      error: payload,
      isAuthenticated: false,
      isAuthenticating: false,
    },
  }),
};

const oAuthAuthenticationReducer = createReducer(reducerBranches, { oAuthUser: initialState });

export default oAuthAuthenticationReducer;
